import { render, staticRenderFns } from "./BtnExcluir.vue?vue&type=template&id=5061176b&"
import script from "./BtnExcluir.vue?vue&type=script&lang=js&"
export * from "./BtnExcluir.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports